import { radioAnatomy as parts } from '@chakra-ui/anatomy'
import { Checkbox } from './Checkbox'

const baseStyleControl = () => {
  const { control = {} } = Checkbox.baseStyle
  return {
    ...control,
    borderRadius: 'full',
    _checked: {
      ...control['_checked'],
      bg: 'transparent',
      pos: 'relative',
      _before: {
        content: '""',
        display: 'block',
        pos: 'absolute',
        top: '50%',
        left: '50%',
        w: '60%',
        h: '60%',
        borderRadius: '50%',
        bg: 'brand.main',
        transform: 'translate(-50%, -50%)'
      }
    }
  }
}

export const Radio = {
  parts: parts.keys,
  baseStyle: {
    label: Checkbox.baseStyle.label,
    control: baseStyleControl()
  },
  sizes: {
    sm: {
      control: {
        width: 3,
        height: 3
      },
      label: {
        fontSize: 'xs'
      }
    },
    md: {
      control: {
        w: 4,
        h: 4
      },
      label: {
        fontSize: 'sm'
      }
    },
    lg: {
      control: {
        w: 5,
        h: 5
      },
      label: {
        fontSize: 'md'
      }
    }
  },
  defaultProps: {
    size: 'sm',
    colorScheme: 'blue'
  }
}
